// actionTypes.js
export const SET_VALUE_RESERVATION = "SET_VALUE_RESERVATION";
export const SET_CURRENT_PAGE_RESERVATION = "SET_CURRENT_PAGE_RESERVATION";
export const SET_ORDER_RESERVATION = "SET_ORDER_RESERVATION";
export const SET_SORT_FIELD_RESERVATION = "SET_SORT_FIELD_RESERVATION";
export const SET_PAGE_SIZE_RESERVATION = "SET_PAGE_SIZE_RESERVATION";
export const SET_CUSTOM_FILTERS_RESERVATION = "SET_CUSTOM_FILTERS_RESERVATION";
export const SET_SORTING_RESERVATION = "SET_SORTING_RESERVATION";
export const SET_ACTIVE_TAB_RESERVATION = "SET_ACTIVE_TAB_RESERVATION";
export const SET_QUERY_RESERVATION = "SET_QUERY_RESERVATION";
export const SET_ACTIF_RESERVATION = "SET_ACTIF_RESERVATION";
export const SET_SELECTED_OPTION_FILTERS_RESERVATION =
  "SET_SELECTED_OPTION_FILTERS_RESERVATION";
export const SET_SELECTED_OPTION_ID_RESERVATION =
  "SET_SELECTED_OPTION_ID_RESERVATION";
export const SET_COLUMN_RESERVATION = "SET_COLUMN_RESERVATION";
